import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexProps } from '../Flex';

export interface DividerBaseProps extends FlexProps {
  /**
   * The divider orientation.
   */
  orientation?: 'horizontal' | 'vertical';
  /**
   * If true, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of 0px if it is the child of a flex container.)
   */
  flexItem?: boolean;
}

export const Divider = styled(Flex).withConfig({
  shouldForwardProp: (prop) => !['orientation', 'flexItem'].includes(prop),
  displayName: 'Divider',
})<DividerBaseProps>`
  display: flex;
  flex-shrink: 0;
  margin: 0;
  border: 0;
  ${({ orientation = 'horizontal' }) =>
    orientation === 'vertical'
      ? `
      height: 100%;
      border-left: 1px solid #efefef;
  `
      : `
      width: 100%;
      border-top: 1px solid #efefef;
  `}
  ${({ flexItem }) =>
    flexItem
      ? `
    align-self: stretch;
    height: auto;
    `
      : ''}
`;
